// Phase 1 KCL house ads. Served from our own origin, so ad blockers leave them alone.
// TODO(kcl): replace the gradient `scene` with licensed high-resolution nature photography
// (put files in client/public/ads/ and set `image`). See CLAUDE.md to-dos.

export interface HouseAd {
  id: string;
  headline: string;
  body: string;
  cta: string;
  url: string;
  image?: string;
  scene: string; // CSS background used when no image is set
}

const KCL_URL = 'https://kcltd.es/?utm_source=kcl-canvas&utm_medium=house-ad';

export const HOUSE_ADS: HouseAd[] = [
  {
    id: 'mountain',
    headline: 'This mountain took 50 million years to build.',
    body: 'Your systems project shouldn’t. Kirkpatrick Consult delivers on time – geologically speaking, instantly.',
    cta: 'Talk to KCL',
    url: KCL_URL,
    scene: 'linear-gradient(180deg, #1e3a8a 0%, #64748b 55%, #e2e8f0 100%)',
  },
  {
    id: 'glacier',
    headline: 'Glaciers move 1 metre a day.',
    body: 'Still faster than most IT change requests. Ours move faster than both.',
    cta: 'Speed things up',
    url: KCL_URL,
    scene: 'linear-gradient(180deg, #0c4a6e 0%, #38bdf8 55%, #f0f9ff 100%)',
  },
  {
    id: 'forest',
    headline: 'A forest runs perfectly without a 300-slide strategy deck.',
    body: 'So can your business. Practical consulting from Kirkpatrick Consult.',
    cta: 'Skip the deck',
    url: KCL_URL,
    scene: 'linear-gradient(170deg, #052e16 0%, #15803d 55%, #bbf7d0 100%)',
  },
  {
    id: 'sea',
    headline: 'Calm waters ahead.',
    body: 'For when your spreadsheets get stormy. Kirkpatrick Consult – systems that just work.',
    cta: 'Find calm',
    url: KCL_URL,
    scene: 'linear-gradient(180deg, #0f172a 0%, #0e7490 60%, #a5f3fc 100%)',
  },
  {
    id: 'owl',
    headline: 'Owls see in the dark.',
    body: 'We see what’s wrong with your data. Both are impressive at parties.',
    cta: 'Shed some light',
    url: KCL_URL,
    scene: 'radial-gradient(circle at 75% 25%, #fef3c7 0 6%, transparent 7%), linear-gradient(180deg, #020617 0%, #1e1b4b 100%)',
  },
];
